"use strict";
/* eslint-env browser */
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const common_1 = require("@prosay/common");
const i18n_1 = require("@prosay/i18n");
const logging_1 = require("@prosay/logging");
const react_1 = __importStar(require("react"));
const react_native_paper_1 = require("react-native-paper");
const util_1 = require("../util");
const logger = logging_1.getLogger(__filename);
const VoiceRecordingSettingsReducerFunction = (previous, action) => {
    switch (action.kind) {
        case "start":
            return {
                state: "recording",
                ...action,
                duration: 0,
            };
        case "durationUpdate":
            common_1.assert(previous.state === "recording", `The durationUpdate action can only be called if you are currently in the recording state (previous state = ${previous.state})`);
            return {
                ...previous,
                ...action,
            };
        case "stop":
            return {
                state: "finished",
                ...action,
            };
        case "clear":
            return {
                audio: undefined,
                state: "initial",
            };
        default:
            return { ...previous };
    }
};
const useVoiceRecordingSettingsReducer = (initial = { state: "initial" }) => react_1.useReducer(VoiceRecordingSettingsReducerFunction, initial);
const getRecordingIconName = (state) => {
    switch (state) {
        case "initial":
            return "microphone";
        case "recording":
            return "stop";
        case "finished":
            return "close";
        default:
            common_1.unreachable();
    }
};
exports.AudioRecorder = ({ disabled = false, messages: { noMicrophoneFound = i18n_1.translate("components.audioRecorder.noMicrophoneFound"), startedRecording = i18n_1.translate("components.audioRecorder.startedRecording"), } = {}, setState, sendSnackMessage, }) => {
    const [microphoneNotFound, setMicrophoneNotFound] = react_1.useState(false);
    const recordingHandleRef = react_1.useRef();
    const [recording, dispatchRecordingAction,] = useVoiceRecordingSettingsReducer();
    react_1.useEffect(() => {
        if (recording.state !== "recording") {
            return () => { };
        }
        const interval = setInterval(async () => {
            common_1.assert(recordingHandleRef.current);
            const duration = await recordingHandleRef.current.duration();
            dispatchRecordingAction({
                duration,
                kind: "durationUpdate",
            });
            logger.debug `Updated audio duration to ${duration}`;
        }, 500);
        logger.debug `Started interval for updating audio duration...`;
        return () => {
            logger.debug `Cleared interval for updating audio duration`;
            clearInterval(interval);
        };
    }, [recording.state, dispatchRecordingAction]);
    // update the given reference
    react_1.useEffect(() => setState(recording), [recording, setState]);
    const onPress = react_1.useCallback(() => common_1.runAsync(async () => {
        if (microphoneNotFound) {
            logger.warn `Could not find microphone!`;
            sendSnackMessage(noMicrophoneFound);
            return;
        }
        logger.debug `Called onPress with the following recording state: ${recording.state}`;
        switch (recording.state) {
            case "initial":
                try {
                    recordingHandleRef.current = await util_1.recordAudio();
                }
                catch (e) {
                    if (e.name === "NotFoundError") {
                        setMicrophoneNotFound(true);
                        return;
                    }
                    throw e;
                }
                sendSnackMessage(startedRecording);
                dispatchRecordingAction({
                    kind: "start",
                });
                break;
            case "recording": {
                common_1.assert(recordingHandleRef.current);
                await recordingHandleRef.current.stop();
                const data = await recordingHandleRef.current.retrieve();
                common_1.assert(data);
                dispatchRecordingAction({
                    blob: util_1.dataUriToBlob(data.uri),
                    duration: data.duration,
                    kind: "stop",
                });
                break;
            }
            case "finished":
                dispatchRecordingAction({
                    kind: "clear",
                });
                break;
            default:
                common_1.unreachable();
        }
    }), [
        dispatchRecordingAction,
        noMicrophoneFound,
        microphoneNotFound,
        recording.state,
        sendSnackMessage,
        startedRecording,
    ]);
    return (react_1.default.createElement(react_native_paper_1.Button, null,
        react_1.default.createElement(react_native_paper_1.IconButton, Object.assign({ icon: getRecordingIconName(recording.state) }, { disabled, onPress }))));
};
//# sourceMappingURL=data:application/json;base64,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